module.exports = __webpack_public_path__ + "img/undraw_Setup_re_y9w8.937ad8f7.svg";